import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import {  Repository } from "typeorm";
import { FreightsCompany } from "./freights-company-entity";
import { FreightsCompanyRequest, FreightsCompanyResponseModel } from "@gtpl/shared-models/masters";

@Injectable()
export class FreightsCompanyService{
    constructor(
        @InjectRepository(FreightsCompany)
        private repo : Repository<FreightsCompany>,

        
    ) {}

    async getAllActiveFreightsCompanies():Promise<FreightsCompanyResponseModel>{
        try{
            const data = await this.repo.find({where:{isActive: true}})
            if(data.length > 0){
                return new FreightsCompanyResponseModel(true, 1, 'Data retrieved successfully',data)
            }else{
                return new FreightsCompanyResponseModel(false, 0, 'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }
    
    async getAllFreightsCompanies():Promise<FreightsCompanyResponseModel>{
        try{
            // let query = `SELECT p.*,f.name
            // FROM Freight Company p
            // LEFT JOIN factory f ON f.id = p.factory_location_id
            // ORDER BY p.Freight Company_name`
            // const data = await this.dataSource.query(query)

            const data = await this.repo.find()
            if(data.length > 0){
                return new FreightsCompanyResponseModel(true, 1, 'Data retrieved successfully',data)
            }else{
                return new FreightsCompanyResponseModel(false, 0, 'No data found',[])
            }
        }catch(err){
            throw(err)
        }
    }

    async createFreightCompany(dto: FreightsCompanyRequest, isUpdate: boolean): Promise<FreightsCompanyResponseModel> {
        try {
            let res =[]
            console.log(dto,'9999999999999999999999999999')
            if (!isUpdate) {
                const existing = await this.repo.findOne({ where: { name: dto.name } });
                if (existing) {
                    throw new Error('Freight Company already exists');
                }
            }
            
            const entityData = new FreightsCompany();
            entityData.name = dto.name
            entityData.code = dto.code
            entityData.linerAddress=dto.linerAddress
            entityData.isActive = dto.isActive === undefined || dto.isActive === null ? true : dto.isActive;
            if (isUpdate) {
                console.log(dto,'pppppppppp');
                
                entityData.id = dto.id;
                entityData.updatedUser = dto.updatedUser;
            } else {
                entityData.createdUser = dto.createdUser;
            }
            console.log(entityData,'&&&&&&&&&&&&&&&&&&&&')
            const data = await this.repo.save(entityData);
            console.log(entityData,"dataaaaaaaaaaaaaa6666666666666666666");
            
            res.push(new FreightsCompanyRequest(data.id,data.name,data.code,data.linerAddress,data.isActive,data.createdAt,data.createdUser,data.updatedAt,data.updatedUser,data.versionFlag))
            return new FreightsCompanyResponseModel(true, 1, isUpdate ? 'Freight Company updated successfully' : 'Freight Company created successfully', res);
        } catch (err) {
            throw err;
        }
    }

    async activateDeactivateFreightCompany(req: FreightsCompanyRequest): Promise<FreightsCompanyResponseModel> {
        try {
            const finish = await this.repo.findOne({ where: { id: req.id } });
            if (!finish) throw new FreightsCompanyResponseModel(false, 99998, 'No Records Found');
            
            const message = finish.isActive === req.isActive ? `already ${req.isActive ? 'activated' : 'deactivated'}` : `successfully ${req.isActive ? 'activated' : 'deactivated'}`;
            const responseCode = finish.isActive === req.isActive ? req.isActive ? 10112 : 10115 : req.isActive ? 10114 : 10115;
    
            await this.repo.update({ id: req.id }, { isActive: req.isActive, updatedUser: req.updatedUser });
    
            return new FreightsCompanyResponseModel(true, responseCode, `Freight Company is ${message}`);
        } catch (err) {
            return err;
        }
    }
    
    
    

}